var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.724,32.782a38.974,38.974,0,0,1-8.138-11.75,2.309,2.309,0,0,1,.512-2.551l2.527-2.523a4.719,4.719,0,0,0,.262-6.805L17.266,5.531a6.169,6.169,0,0,0-8.724,0L6.53,7.542A9.852,9.852,0,0,0,3.908,16.4c1.524,8.061,6.207,16.886,13.762,24.441S34.05,53.074,42.111,54.6a9.853,9.853,0,0,0,8.854-2.622l2.008-2.008a6.168,6.168,0,0,0,0-8.724l-3.619-3.618a4.625,4.625,0,0,0-6.543,0l-2.786,2.789a2.31,2.31,0,0,1-2.551.512,39.054,39.054,0,0,1-11.75-8.144Z","transform":"translate(2.747 0.676)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M0,0H64V64H0Z","fill":"none","key":1})]);
}

IconPhone.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
